import React from 'react';
import { Router, Route, Switch, NavLink } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import ReactGA from 'react-ga';
import CookieConsent from "react-cookie-consent";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Extraction from './Extraction';
import About from './About';
import Header from './Header';
import Error from './Error';
import Footer from './Footer';
import Imprint from './Imprint';
import PrivacyPolicy from './PrivacyPolicy';

function App() {

    const THEME = createMuiTheme({
        typography: {
            "fontFamily": `"Source Sans Pro", sans-serif`,
            "fontSize": 14,
            "color": "#444444"
        }
        });

    const history = createHistory()
    const trackingId = "UA-153895943-7";
    ReactGA.initialize(trackingId);
    ReactGA.pageview(window.location.pathname + window.location.search);
    history.listen((location, action) => {
        ReactGA.pageview(location.pathname + location.search);
    });
    return (
        <MuiThemeProvider theme={THEME}>
            <Router history={history}>
                <div className="App">
                    <div className="content-wrap">
                        <Header />
                        <Switch>
                            <Route path="/" component={Extraction} exact />
                            <Route path="/about" component={About} />
                            <Route path="/imprint" component={Imprint} />
                            <Route path="/privacy-policy" component={PrivacyPolicy} />
                            <Route component={Error} />
                        </Switch>
                        <Footer />
                        <CookieConsent
                            buttonText="Accept"
                            debug={false}
                            style={{ background: "#00adee" }}
                            buttonStyle={{ background: "#E57200", color: "#FFFFFF", fontSize: "inherit" }}
                        >
                            <h4>This website uses cookies.</h4>
                            <p>This website uses cookies to improve your experience on our website. 
                                By continuing to browse this site you are agreeing to our use of cookies. 
                                You can disable cookies in your browser settings at any time. More information in our Privacy Policy. <NavLink to="/privacy-policy">Read more</NavLink></p>                            
                        </CookieConsent>
                    </div>
                </div>
            </Router>
        </MuiThemeProvider>

    );
}

export default App;